"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialShareWidget = SocialShareWidget;
const react_1 = __importStar(require("react"));
const building_blocks_ui_theme_1 = require("@acko-tech/building-blocks.ui.theme");
const config_1 = require("./config");
const Styles = __importStar(require("./social-share-widget-styles"));
const building_blocks_ui_typography_1 = require("@acko-tech/building-blocks.ui.typography");
function SocialShareWidget({ postUrl = '', textStyles = {}, ctaText = 'Share Post', sharePostIconStyles = { stroke: "white" }, socialShareIconStyles = { fill: '#1B73E8' }, widgetType = 'SEO revamp widget' }) {
    var _a, _b, _c;
    const [showDropdown, setShowDropdown] = (0, react_1.useState)(false);
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const dropdownRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (typeof document === 'undefined')
            return;
        function onClickOutside(event) {
            var _a;
            if (((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.id) === 'bottomSheet') {
                setShowDropdown(false);
            }
            if ((dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) !== null) {
                const isClickInside = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current.contains(event.target);
                if (!isClickInside) {
                    setShowDropdown(false);
                }
            }
        }
        document.addEventListener('click', onClickOutside);
        document.addEventListener('scroll', onClickClose);
        return () => {
            document.removeEventListener('click', onClickOutside);
            document.removeEventListener('scroll', onClickClose);
        };
    }, []);
    const onClickClose = () => {
        setShowDropdown(false);
    };
    return (react_1.default.createElement(Styles.Wrapper, { ref: dropdownRef },
        react_1.default.createElement(Styles.SharePost, { onClick: () => setShowDropdown(!showDropdown) },
            react_1.default.createElement(Styles.SharePostIcon, Object.assign({}, sharePostIconStyles)),
            react_1.default.createElement(building_blocks_ui_typography_1.P2, { theme: theme, styles: Object.assign({ color: (_c = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.light) === null || _b === void 0 ? void 0 : _b.primary) === null || _c === void 0 ? void 0 : _c.n0, margin: 0 }, textStyles) }, ctaText)),
        showDropdown && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Styles.DropdownListWrapper, { id: "bottomSheet", theme: theme },
                react_1.default.createElement(Styles.DropdownList, { theme: theme },
                    react_1.default.createElement(Styles.BottomSheetHeader, { hideClose: false, theme: theme },
                        react_1.default.createElement(building_blocks_ui_typography_1.T2, { theme: theme, styles: Object.assign({ margin: 0 }, textStyles) }, "Share Post"),
                        react_1.default.createElement(Styles.CrossIconContainer, { onClick: onClickClose },
                            react_1.default.createElement(Styles.CrossIcon, { theme: theme }))),
                    react_1.default.createElement(react_1.default.Fragment, null, config_1.ListItems === null || config_1.ListItems === void 0 ? void 0 : config_1.ListItems.map((item, index) => {
                        const Renderer = item === null || item === void 0 ? void 0 : item.renderer;
                        return (react_1.default.createElement(Renderer, { item: item, key: index, theme: theme, postUrl: postUrl, socialShareIconStyles: socialShareIconStyles, ctaText: ctaText, widgetType: widgetType }));
                    }))))))));
}
//# sourceMappingURL=social-share-widget.js.map